import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import VipUpgradeModal, {VipUpgradeRef} from '../modal/vip-upgrade';
import {checkPopupVipUpgrade} from '../vip.service';
import {useLogin} from '@/utils/state-hooks';
export const VipUpgradeContext = createContext<{
  showVipUpgrade: (cb?: () => void) => void;
}>({
  showVipUpgrade: () => {},
});

export const VipUpgradeProvider = ({children}: {children: React.ReactNode}) => {
  const login = useLogin();
  const showVipUpgrade = useCallback(
    (cb?: () => void) => {
      if (!login) {
        return;
      }
      checkPopupVipUpgrade().then(res => {
        if (res.status) {
          vipUpgradeModalRef.current?.show(res.changeExperience);
          localStorage.setItem('vipBaseExp', res.changeExperience / 2 + '');
          cb?.();
        }
      });
    },
    [login],
  );
  const contextValue = useMemo(() => ({showVipUpgrade}), [showVipUpgrade]);
  const [preloadImages, setPreloadImages] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setPreloadImages(true);
    }, 1000);
  }, []);
  const vipUpgradeModalRef = useRef<VipUpgradeRef>(null);
  return (
    <VipUpgradeContext.Provider value={contextValue}>
      {children}
      <VipUpgradeModal ref={vipUpgradeModalRef} />
      {/* 预加载图片 */}
      {preloadImages && (
        <>
          <div
            className="absolute invisible -top-[9999px] -left-[9999px]"
            style={{
              background: `url(${require('@/assets/imgs/vip/v2/person.webp')})`,
            }}
          />
          <div
            className="absolute invisible -top-[9999px] -left-[9999px]"
            style={{
              background: `url(${require('@/assets/imgs/vip/v2/week-card-rewards.webp')})`,
            }}
          />
          <div
            className="absolute invisible -top-[9999px] -left-[9999px]"
            style={{
              background: `url(${require('@/assets/imgs/vip/v2/weekly-rewards.webp')})`,
            }}
          />
        </>
      )}
    </VipUpgradeContext.Provider>
  );
};
